import { useEffect, ReactNode } from "react"
import axios from "axios"
import { useAuth0 } from "@equipmentshare/auth0-react"

import { API_URL } from "@app/services/env"

export function AxiosInterceptorsProvider({ children }: { children: ReactNode }) {
	const { getAccessTokenSilently } = useAuth0()

	useEffect(() => {
		axios.defaults.baseURL = API_URL

		const reqId = axios.interceptors.request.use(async (config) => {
			const token = await getAccessTokenSilently()
			config.headers.Authorization = `Bearer ${token}`
			return config
		})

		return () => {
			axios.interceptors.request.eject(reqId)
		}
	}, [getAccessTokenSilently])

	return <>{children}</>
}
